<template>
  <div class="list">
    <header-bar></header-bar>
    <section class="main cl">
      <div class="main-left bg-white fl pt50">
        <div class="content pt80">
          <img src="@/assets/images/img/404.png" alt="" class="mt80">
          <div class="mt20">
            <el-button type="primary" @click="$router.push('/')">返回首页</el-button>
          </div>
        </div>
      </div>
      <div class="main-right fr">
        <com-foot></com-foot>
      </div>
    </section>
    <back-top></back-top>
  </div>
</template>

<script>
import HeaderBar from "@/components/Header.vue";
import BackTop from "@/components/BackTop.vue";
import ComFoot from "@/components/ComFoot.vue";
export default {
  name: "List",
  components: {
    HeaderBar,
    BackTop,
    ComFoot
  },
  data() {
    return {
    };
  },
  methods: {
    
  },
  created() {

  },
};
</script>

<style scoped lang="scss">
.main {
  width: 1000px;
  padding-top: 70px;
  margin: 0 auto;
  .main-left {
    width: 680px;
    .content{
      height: 600px;
      text-align: center;
    }
  }
  .main-right {
    width: 310px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/404.vue